'use client';

import { FC } from 'react';

import { Heading } from '@purpur/library';
import type { EntryFields } from 'contentful';

import { RichTextContent } from '@telialt/common-rich-text-content/src/RichTextContent';

import { ContentTitleContainer } from './ContentTitle.styles';

type Props = {
    title: string;
    description?: EntryFields.RichText;
    isCentered?: boolean;
};

export const ContentTitle: FC<Props> = ({ title, description, isCentered }) => {
    return (
        <ContentTitleContainer $isCentered={isCentered}>
            <Heading tag="h1" variant="title-500">
                {title}
            </Heading>
            <RichTextContent richText={description} />
        </ContentTitleContainer>
    );
};
